/**
 * FormFieldWrapper component.
 */
import React, { Component } from 'react';
import { Form, Icon as IconOld } from 'semantic-ui-react';
import cx from 'classnames';
import { defineMessages, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
/* START CUSTOMIZATION */
import { LockedSchemaFieldsContext } from '../../../../../helpers/LockedSchemaFieldsContext';
/* END CUSTOMIZATION */

const messages = defineMessages({
  edit: {
    id: 'Edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'Delete',
    defaultMessage: 'Delete',
  },
});

type FormFieldWrapperProps = {
  id: string;
  isDisabled?: boolean | null;
  onEdit?: (id: string) => void;
  className?: string;
  onDelete?: ((id: string) => void) | null;
  intl: IntlShape;
  multilingual_options?: { language_independent?: boolean };
  children?: React.ReactNode;
};

/**
 * FormFieldWrapper component class.
 * @class FormFieldWrapper
 * @extends Component
 */
class FormFieldWrapper extends Component<FormFieldWrapperProps> {
  /* START CUSTOMIZATION */
  // Field IDs the surrounding schema editor marks as locked (event-registration
  // forms, #1662): suppress the edit/delete toolbar so they are non-editable and
  // non-removable. The SchemaWidget's Draggable row keeps them re-orderable.
  // Empty for every form that does not provide the context — a no-op elsewhere.
  // Kein `declare context` hier: Razzles babel-loader kann TypeScripts
  // `declare`-Klassenfelder nicht transformieren und bricht den Build ab.
  // Der Typ kommt stattdessen an der Verwendungsstelle dazu.
  static contextType = LockedSchemaFieldsContext;
  /* END CUSTOMIZATION */

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    const {
      id,
      onEdit,
      className,
      isDisabled,
      onDelete,
      intl,
      multilingual_options,
    } = this.props;

    /* START CUSTOMIZATION */
    const lockedFields =
      (this.context as React.ContextType<typeof LockedSchemaFieldsContext>) ||
      [];
    const isLocked = lockedFields.includes(id);
    /* END CUSTOMIZATION */

    return (
      <Form.Field
        className={cx(
          className,
          `field-wrapper-${id}`,
          multilingual_options?.language_independent
            ? 'language-independent-field'
            : null,
        )}
      >
        {/* START CUSTOMIZATION */}
        {onEdit && !isDisabled && !isLocked && (
          /* END CUSTOMIZATION */
          <div className="toolbar" style={{ zIndex: '2' }}>
            <button
              aria-label={intl.formatMessage(messages.edit)}
              className="item ui noborder button"
              onClick={(evt) => {
                evt.preventDefault();
                onEdit(id);
              }}
            >
              <IconOld name="write square" size="large" color="blue" />
            </button>
            <button
              aria-label={intl.formatMessage(messages.delete)}
              className="item ui noborder button"
              onClick={(evt) => {
                evt.preventDefault();
                onDelete?.(id);
              }}
            >
              <IconOld name="close" size="large" color="red" />
            </button>
          </div>
        )}
        {this.props.children}
      </Form.Field>
    );
  }
}

export default injectIntl(FormFieldWrapper);
